
/**
 * @nullable
 */
export type MarkNotificationAsRead200Data = {[key: string]: unknown} | null;
